/* eslint-disable max-len */
/* eslint-disable no-undef */
import React from "react";
import { Link } from "react-router-dom";
import EventService from '../../../../services/EventService';
import MasterService from '../../../../services/MasterService';
import moment from "moment";
export const userData = localStorage.getItem("persist:root")
  ? JSON.parse(JSON.parse(localStorage.getItem("persist:root")).userData)
  : "";
import editicoSvg from "../../../../public/edit-product.svg";
import { Chart } from "react-google-charts";
import { showLoading } from 'react-global-loading';
import Modal from 'react-modal';
import EventModal from "./EventModel";



class ViewAllEvents extends React.Component {

  constructor(props) {
    super(props);
    const url = new URL(window.location);

    this.state = {

      eventsList: [],
      filteredList: [],
      upcoming: '',
      categories: [],
      approved: '', pending: '',
      data: [
        ["months", "Approved", "Disapproved"],
        ["Jan", 400, 400],
        ["Feb", 700, 460],
        ["Mar", 660, 0],
        ["Apr", 870, 540],
        ["May", 400, 400],
        ["Jun", 700, 460],
        ["Jul", 660, 0],
        ["Aug", 870, 540],
        ["Sept", 400, 400],
        ["Oct", 700, 460],
        ["Nov", 660, 0],
        ["Dec", 870, 540],
      ], limit: 5, fullyLoaded: false, currentPage: url.searchParams.get('page') ? parseInt(url.searchParams.get('page')) : 1, statusType: 1, statusCount: {}, selectedCategory: '', location: '', searchQuery: '',
      chart: {
        title: "Company Performance",
        subtitle: "Sales, Expenses, and Profit: 2014-2017"
      },
      showModal: false,
      selectedEvent: null,
    };
  }

  getSetQueryParams = () => {
    let queryParams = {}

    if (url.searchParams.get('uname')) {
      queryParams = { 'uname': url.searchParams.get('uname') }
    }
    if (url.searchParams.get('location')) {
      queryParams = { 'location': url.searchParams.get('location') }
    }


    return queryParams;
  }

  componentDidMount = () => {

    this.getCategories();
    this.filterdata()
    // if (this.state.currentPage > 1) {

    //   for (let i = 1; i <= this.state.currentPage; i++) {
    //     this.getEventList(i, this.state.statusType);
    //   }
    // }
    // else this.getEventList(this.state.currentPage, this.state.statusType);
  };

  handleShowModal = (event) => {
    this.setState({
      showModal: true,
      selectedEvent: event
    });
  };

  handleCloseModal = () => {
    this.setState({
      showModal: false,
      selectedEvent: null
    });
  };


  onLoad = () => {
    let currentPage = this.state.currentPage;
    currentPage++;
    this.setState({ currentPage })

    const url = new URL(window.location);
    url.searchParams.set('page', currentPage);
    window.history.pushState(null, '', url.toString());
    // this.setState(
    //   prev => ({
    //     ...prev,
    //     query: {
    //       ...prev.query,
    //       ...{ page: parseInt(this.state.currentPage) + 1 }
    //     }
    //   }))
    let currentQuery = this.state.query;
    // this.setState(prevState => ({
    //   query: {
    //     ...prevState.query,
    //     page: currentPage
    //   }
    // }));
    currentQuery.page = currentPage;
    this.setState({ query: currentQuery });
    // this.filterdata();
    // this.getProductList(query);
    EventService.getAllEvents(this.state.query)
      .then((result) => {
        if (!result) {
          return;
        }
        showLoading(true);
        this.setState((prevState) => ({
          statusCount: result,
          filteredList: [...prevState.filteredList, ...result.data]
        }));
        showLoading(false);
      })
      .catch((err) => {
        showLoading(false);
        console.error(err);
      });
  }



  filterdata = () => {

    const url = new URL(window.location);
    { this.state.selectedCategory ? url.searchParams.set('cat', this.state.selectedCategory) : url.searchParams.delete('cat') }
    { this.state.location ? url.searchParams.set('location', this.state.location) : url.searchParams.delete('location') }
    { this.state.statusType ? url.searchParams.set('status', this.state.statusType) : url.searchParams.delete('status') }
    { this.state.searchQuery ? url.searchParams.set('s', this.state.searchQuery) : url.searchParams.delete('s') }
    // { this.state.currentPage ? url.searchParams.set('page', this.state.currentPage) : url.searchParams.delete('page') }
    url.searchParams.delete('page')
    this.setState({ currentPage: 1 })
    let query = {};
    this.setState({ query })
    this.state.selectedCategory && (query.category = this.state.selectedCategory);
    this.state.location && (query.location = this.state.location);
    this.state.statusType && (query.status = this.state.statusType);
    // this.state.currentPage && (query.page = this.state.currentPage);

    this.state.searchQuery && (query.s = this.state.searchQuery);
    this.getEventList(query)
    window.history.pushState(null, '', url.toString());

  }


  getCategories = () => {
    MasterService.getCategories()
      .then((result) => {
        if (!result) {
          return;
        }
        this.setState({ categories: result });
      })
      .catch((err) => {

        console.error(err);
      });
  };

  getEventList = (query) => {
    showLoading(true);
    EventService.getAllEvents(query)
      .then((result) => {
        if (!result) {
          return;
        }
        console.log('result', result)
        showLoading(true);
        this.setState({ filteredList: result.data, statusCount: result })
        // this.setState((prevState) => ({
        //   statusCount: result,
        //   filteredList: [...prevState.filteredList, ...result.data]
        // }));
        showLoading(false);
      })
      .catch((err) => {
        showLoading(false);
        console.error(err);
      });
  };

  deleteEvent2 = async (id) => {
    const isConfirmed = window.confirm("Are you sure you want to delete this event?");
    if (!isConfirmed) {
      return; // Exit the function if deletion is not confirmed
    }
    const url = 'https://agpuat.digitalindiacorporation.in/agp/index.php/wp-json/wp/v2/agp_delete_post';

    const requestBody = {
      id: id,
      action: 'delete',
      type: 'events'
    };

    try {
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(requestBody)
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      console.log('Delete response:', data); // Log the response

      // Check if the message exists and is not empty
      if (data.message) {
        console.log('Message to show:', data.message);
        alert(data.message); // Display the alert
        ToastService.success(data.message);
        // You can also show a success message or update UI
        this.getEventList(this.state.query)
        window.location.reload();
      } else {
        console.warn('No message in response data');
      }

      ToastService.success(data.message);
      window.location.reload();
    } catch (error) {
      console.error('Error deleting events:', error);
    }
  };


  eventType = (page, type) => {
    let filteredList = [], query = {};
    this.setState({ statusType: type });
    const url = new URL(window.location);
    url.searchParams.set('page', page);
    window.history.pushState(null, '', url.toString());
    query.page = 1, query.status = type;
    this.getEventList(query);
    this.setState({ filteredList });
    // this.setState({ eventType: type });
    // let filteredList = [];
    // this.state.eventsList.map((item, index) => {

    //   switch (type) {
    //     case 1://all
    //       filteredList = this.state.eventsList;
    //       this.setState(: '' });
    //       break;
    //     case 2://pending
    //       item.post_status === "pending" && filteredList.push(item);
    //       break;
    //     case 3://approved
    //       item.post_status === "publish" && filteredList.push(item);
    //       break;
    //     case 4://upcoming
    //       (moment(item.date_of_event || item?.start_date).isSameOrAfter(moment(), 'day') && item.post_status === "publish") && filteredList.push(item);
    //       break;
    //     case 5://pincode
    //       item.pincode === this.stat && filteredList.push(item);
    //       break;
    //     case 6://domain
    //       this.setState({ selectedCategory: categoryId }),
    //         item.category?.length > 0 && item.category?.map((item1, index) => (item1.name === categoryId && console.log("demo===", item, item1.name, categoryId) && filteredList.push(item)));
    //       break;
    //   }
    // });
    // this.setState({ filteredList });
  };

  addEvent = () => {
    this.props.history.push({
      pathname: '/super/create-event'
    });
  };


  resetFilter = () => {
    const url = new URL(window.location);
    url.searchParams.delete('s');
    url.searchParams.delete('location');
    url.searchParams.delete('status');
    url.searchParams.delete('cat');
    this.setState({ selectedCategory: '' })
    window.location.reload()
  }

  pdfDownload = () => {

    const { eventType, filteredList } = this.state;
    MasterService.getPdf("Events", filteredList, eventType);
  };




  render() {
    const { filteredList, statusType, statusCount, categories, selectedCategory, location, searchQuery, showModal, selectedEvent } = this.state;
    let fullyLoaded;
    switch (statusType) {
      case 1://all
        fullyLoaded = filteredList.length === statusCount.total ? true : false;
        break;
      case 2://pending
        fullyLoaded = filteredList.length === statusCount.pending ? true : false;
        break;
      case 3://approved
        fullyLoaded = filteredList.length === statusCount.approved ? true : false;
        break;
    }
    return (
      <div className="container-fluid productscontainer" id="main">
        <nav aria-label="breadcrumb">
          {/* <ol className="breadcrumb">
            <li className="breadcrumb-item"><a href="#">Home</a></li>
            <li className="breadcrumb-item active" aria-current="page">All</li>
          </ol> */}
        </nav>
        <hr></hr>

        <div className="row">
          <div className="col-md-8">
            <h3><b>Events</b></h3>
          </div>
          <div className="col-md-4 btr">
            {/* <button className="btn btndbg" onClick={() => this.pdfDownload()}>
              Export
            </button > */}
            <button className="btn theme-btn-fill btndbg" onClick={() => this.addEvent()}> Add Event </button >
          </div>
        </div>
        <div className="row mt-3">
          <div className="col-12">
            <ul className="nav nav-tabs admintabs" id="myTab" role="tablist">
              <li className="nav-item" role="presentation">
                <button className="nav-link" data-bs-toggle="tab" type="button" role="tab" aria-controls="view-all-events-pane" onClick={() => this.eventType(1, 1)} aria-selected="true">All <span className="badge text-bg-secondary rounded-circle p-2">{statusCount.total}</span></button>
              </li>
              <li className="nav-item" role="presentation">
                <button className="nav-link" data-bs-toggle="tab" type="button" role="tab" aria-controls="view-all-events-pane" onClick={() => this.eventType(1, 3)} aria-selected="true">Approved <span className="badge text-bg-secondary rounded-circle p-2">{statusCount.approved}</span></button>
              </li>
              <li className="nav-item" role="presentation">
                <button className="nav-link" data-bs-toggle="tab" type="button" role="tab" aria-controls="view-all-events-pane" onClick={() => this.eventType(1, 2)} aria-selected="true">Pending <span className="badge text-bg-secondary rounded-circle p-2">{statusCount.pending}</span></button>
              </li>

            </ul>
          </div>
        </div>
        <div className="tab-content bg-white p-3 mt-4" id="myTabContent">
          <div className="tab-pane fade show active" id="view-all-events-pane" role="tabpanel" aria-labelledby="#view-all-events">
            <div className="row mt-4 mx-1 p-2 border border-1 rounded rounded-4" id="#view-all-events">
              <div className="col-12">
                <div className="row bg-light p-2">
                  <div className="col-md-12 d-flex align-items-center">
                    <h4>Events</h4>
                  </div>
                  <div className="col-md-4">
                    <label htmlFor="productname" id="username" className="bldlbl hdlb">Search by user name</label>
                    <input type="text" className="form-control" aria-labelledby="username" placeholder="Search by user name" onChange={(e) => this.setState({ searchQuery: e.target.value })} onKeyDown={e =>
                      e.key === "Enter" && this.filterdata()} value={searchQuery} />
                  </div>
                  <div className="col-md-4">
                    <label htmlFor="productname" id="location" className="bldlbl hdlb">enter location or pin code</label>
                    <input type="text" className="form-control" aria-labelledby="location" placeholder="Enter location or Pin/ZIP code" onKeyDown={e =>
                      e.key === "Enter" && this.filterdata()} onChange={(e) => this.setState({ location: e.target.value })} value={location} />
                  </div>
                  <div className="col-md-3">
                    <select name='orderby' className='form-control' aria-label='Shop order' value={selectedCategory}
                      onChange={(e) => this.onCategorySelected(e)}>
                      <option defaultValue='selected' value=''> Search By Domain</option>
                      {categories.map((item, index) => <option key={index} value={item.name}>{item.name}</option>)}
                    </select>
                  </div>
                  {/* <div className="col-md-1 hdblk text-end">
                    <div className="usersearchbtn"> <button type="button" className="btn btndbg border-0 rounded-0 p-2" onClick={() => this.filterdata()}>Search</button></div>
                  </div> */}
                  <div className="col-md-1 hdblk text-end">
                    <div className="usersearchbtn"> <button type="button" className="btn theme-btn-fill btndbg border-0 rounded-0 p-2" onClick={() => this.resetFilter()}>Reset</button></div>
                  </div>
                </div>
              </div>
              <hr className="mt-3"></hr>
              <div className="row mt-3 eve-list">
                {filteredList.length > 0 ? filteredList.map((item, index) => <div className="col-md-6" key={index}>
                  <div className="evtcrd">
                    {/* below is the date component */}
                    <div >
                      <div className="date-card dc-size-new">
                        <div className="month w-100">{moment(item.date_of_event || item?.start_date).format("MMM")}</div>
                        <div className="day d-block w-100">{moment(item.date_of_event || item?.start_date).format("DD")}</div>
                        <div className="status d-block w-100"> {item.post_status === "pending" ? "Pending" : "Approved"}</div>
                      </div>
                    </div>
                    {/* below is the event details right part */}
                    <div className="border-bottom border-secondary-subtle w-100">
                      <div className="d-flex justify-content-between align-items-start">
                        <h4 className="mb-3 crop-text"><Link to={{
                          pathname: "/super/event-details",
                          search: `?id=${item.ID}`,
                          state: { eventDetails: item }
                        }} >{item.post_title}</Link></h4>
                        <div className="d-flex gap-2">
                          <span className="text-mute" style={{ cursor: 'pointer' }} onClick={() => this.handleShowModal(item)}><i className="fa fa-edit" aria-hidden="true"></i></span>
                          <span className="text-danger" style={{ cursor: 'pointer' }} onClick={() => this.deleteEvent2(item.ID)}><i className="fa fa-trash" aria-hidden="true"></i></span>

                        </div>

                      </div>

                      <span className="eve-time">Time: <b className="text-dark"> {moment(item?.time_of_event || item?.start_time, ["HH:mm"]).format("hh:mm A")}</b></span>
                      <span className="eve-date mx-3">Date: <b className="text-dark">{moment(item.date_of_event || item?.start_date).format("Do MMM YYYY")}</b></span>
                      <small className="muted d-block mt-2">{item.select_state}, {item.select_country.blogname}</small>

                      <div className="edit-icon d-flex justify-content-start gap-2">
                        {/* <img
                          src={editicoSvg}
                          alt="edit product"
                          style={{ cursor: 'pointer' }} // Ensures the icon looks clickable
                        /> */}

                      </div>

                      {/* Modal component */}

                      {/* <div className="usersearchbtn">
                        <button className="btn w-25 border-0 rounded-0 bg-danger text-white" onClick={() => this.deleteEvent2(item.ID)}>
                          Delete
                        </button>
                      </div> */}
                    </div>
                  </div>
                </div>) : <span>No Event found</span>}
                {filteredList.length > 0 ? (fullyLoaded ? <span> </span> : <div
                  style={{
                    width: "100%",
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <button
                    style={{
                      backgroundColor: "#beeadc",
                      border: "none",
                      borderRadius: "10px",
                      padding: "10px 2rem",
                      fontWeight: "semibold",
                    }}
                    onClick={e => this.onLoad()}
                  >
                    Load More
                  </button>
                </div>) : ''}

                <EventModal
                  show={showModal}
                  handleClose={this.handleCloseModal}
                  eventDetails={selectedEvent}
                />

              </div>
            </div>

          </div>

        </div>
      </div>
    );
  }
}
export default ViewAllEvents;